import * as React from 'react';
import './App.css';
import NavBarLayout from './NavbarLayout';
import Button from '@mui/material/Button';
import { useNavigate} from 'react-router-dom';
import { buttonStyle } from './colors';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function AddMethods(props) {
  const navigate = useNavigate();
  const [openPhoto, setOpenPhoto] = React.useState(false);
  const [openEmail, setOpenEmail] = React.useState(false);

 

  const handleClickOpenPhoto = () => {
   
    setOpenPhoto(true);
  };

  const handleClosePhoto = () => {
    setOpenPhoto(false);
  };

  const handleClickOpenEmail = () => {
    setOpenEmail(true);
  };

  const handleCloseEmail = () => {
    setOpenEmail(false);
  };


  

  return (
    <NavBarLayout title="Add Clothes" onBackButtonClicked={() => navigate("/mycloset")} active={1}>
      <div className="AddMethods-container">
        
        <span className='AddMethod-instructionsText'>
         How do you want to add clothes to your virtual closet?
         </span>
         <div className='AddMethod-buttonCaption'>
         <Button onClick={handleClickOpenPhoto} sx={{fontSize: 20, padding: 2, ...buttonStyle}} variant="contained">Add from photos</Button>
          <span className='AddMethod-captionText'>
          Automatically add outfits and clothes you’ve worn based on your photos! 
          </span>
         </div>

         <div className='AddMethod-buttonCaption'>
        <Button onClick={handleClickOpenEmail} sx={{fontSize: 20, padding: 2, ...buttonStyle}} variant="contained">Add from email</Button>
        <span className='AddMethod-captionText'>
        Automatically add clothes purchased using email receipts!
        </span>
        </div>

        <div className='AddMethod-buttonCaption'>
        <Button onClick={() => navigate("/camerascreen")} sx={{fontSize: 20, padding: 2, ...buttonStyle}} variant="contained">Add manually</Button>
        <span className='AddMethod-captionText'>
        Take a picture of your clothes!
        </span>    
        </div>  
      </div>

      <Dialog
        open={openPhoto}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClosePhoto}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Allow #OOTD to access your photos?"}</DialogTitle>
        <DialogActions sx={{justifyContent: "space-evenly !important"}}>
          <Button onClick={handleClosePhoto}>No</Button>
          <Button onClick={() => navigate("/autoaddresults", {state:{id:1,type:'Photos'}})}>Yes</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openEmail}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseEmail}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Allow #OOTD to access your email?"}</DialogTitle>
        <DialogActions sx={{justifyContent: "space-evenly !important"}}>
          <Button onClick={handleCloseEmail}>No</Button>
          <Button onClick={() => navigate("/autoaddresults", {state:{id:1,type:'Email'}})}>Yes</Button>
        </DialogActions>
      </Dialog>
    </NavBarLayout>
  );
}

export default AddMethods;